import TestimonialController from './Controller/TestimonialController';

$(document).ready(function () {
    new TestimonialController();
});